/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Text } from '@blend/enterprise-components';

export const TableCell: React.FC<{ value: string }> = ({ value }) => {
  return <Text>{value}</Text>;
};
